<template>
  <NuxtLayout name="default">
    <div class="flex grow flex-col px-page_padding pb-16 pt-6 font-secondary">
      <slot />
    </div>
  </NuxtLayout>
</template>
